var map = {
	"./images/ActiveLogo/helpActive.svg": 22038,
	"./images/ActiveLogo/homeActive.svg": 69268,
	"./images/ActiveLogo/instructorsUser.svg": 42844,
	"./images/ActiveLogo/langaugeActive.svg": 91227,
	"./images/ActiveLogo/mySessionActive.svg": 66245,
	"./images/ActiveLogo/mycourseActive.svg": 31564,
	"./images/ActiveLogo/offerActive.svg": 52568,
	"./images/ActiveLogo/privacyActive.svg": 11925,
	"./images/ActiveLogo/purchaseActive.svg": 24093,
	"./images/ActiveLogo/referfriendActive.svg": 50764,
	"./images/ActiveLogo/settingActive.svg": 69962,
	"./images/ActiveLogo/userActive.svg": 51218,
	"./images/ActiveLogo/wishlistActive.svg": 44614,
	"./images/Authsvgs/facebookLogo.svg": 80911,
	"./images/Authsvgs/googleLogo.svg": 16079,
	"./images/Authsvgs/mail.svg": 20948,
	"./images/Authsvgs/phone.svg": 48319,
	"./images/Banner/leftArrow.svg": 97767,
	"./images/Banner/rightArrow.svg": 97445,
	"./images/Course/downArrow.svg": 72575,
	"./images/Course/download.svg": 24642,
	"./images/Course/eye.svg": 30108,
	"./images/Course/greenRupee.svg": 73388,
	"./images/Course/lock.svg": 76162,
	"./images/Course/rightMark.svg": 57486,
	"./images/Course/share.svg": 35657,
	"./images/Course/watch.svg": 49123,
	"./images/Episodes/dislike.svg": 49286,
	"./images/Episodes/external-link.svg": 10491,
	"./images/Episodes/filledDislike.png": 93390,
	"./images/Episodes/filledLike.svg": 94833,
	"./images/Episodes/like.svg": 63949,
	"./images/Episodes/play.svg": 21402,
	"./images/Episodes/watchEpisode.svg": 3056,
	"./images/Error/error_404.svg": 25771,
	"./images/Error/error_500.svg": 21283,
	"./images/Feedback/happy.svg": 79290,
	"./images/Feedback/happyFilled.svg": 10031,
	"./images/Feedback/neutral.svg": 28954,
	"./images/Feedback/neutralFilled.svg": 98576,
	"./images/Feedback/sad.svg": 64469,
	"./images/Feedback/sadFilled.svg": 63774,
	"./images/Group.svg": 42719,
	"./images/Hamburger.svg": 26257,
	"./images/Home/carbon_play_filled.svg": 1134,
	"./images/Home/empty-heart.svg": 35440,
	"./images/Home/filledHeart.svg": 5438,
	"./images/Home/filter.svg": 61984,
	"./images/Home/heart.svg": 88107,
	"./images/Home/notification.svg": 54600,
	"./images/Home/notificationWithRed.svg": 11544,
	"./images/Home/playicon.svg": 86075,
	"./images/Home/profile.svg": 4068,
	"./images/Instructor/watchIntro.svg": 68997,
	"./images/Invoicelogo.svg": 61545,
	"./images/Logo.svg": 10953,
	"./images/Mycourse/mycourseCard.png": 66781,
	"./images/Mycourse/playicon.svg": 54652,
	"./images/Mycourse/viewInvoice.svg": 70770,
	"./images/Payment/Paymentsuccess.svg": 61466,
	"./images/Payment/coupon.svg": 97151,
	"./images/Payment/paymenterror.svg": 79266,
	"./images/Profile/calendar.svg": 5895,
	"./images/Profile/camera.svg": 1478,
	"./images/Profile/delete.svg": 48734,
	"./images/Profile/edit.svg": 680,
	"./images/Profile/email.svg": 26204,
	"./images/Profile/logout.svg": 48571,
	"./images/Profile/phone.svg": 53569,
	"./images/ProfileSkeleton.svg": 13138,
	"./images/ReferFriend/circle.svg": 73384,
	"./images/ReferFriend/information.svg": 3820,
	"./images/ReferFriend/one.svg": 16058,
	"./images/ReferFriend/referImg.svg": 17148,
	"./images/ReferFriend/referLfd.svg": 71296,
	"./images/ReferFriend/three.svg": 39327,
	"./images/ReferFriend/two.svg": 99523,
	"./images/Sidebar/course.svg": 44081,
	"./images/Sidebar/downloads.svg": 51451,
	"./images/Sidebar/help.svg": 8645,
	"./images/Sidebar/home.svg": 8379,
	"./images/Sidebar/instructorsUser.svg": 76043,
	"./images/Sidebar/langauge.svg": 85532,
	"./images/Sidebar/mySession.svg": 25997,
	"./images/Sidebar/offer.svg": 27489,
	"./images/Sidebar/privacy.svg": 50791,
	"./images/Sidebar/purchase.svg": 55000,
	"./images/Sidebar/refer.svg": 93990,
	"./images/Sidebar/setting.svg": 14200,
	"./images/Sidebar/user.svg": 24478,
	"./images/Sidebar/whishlist.svg": 37257,
	"./images/Vector2.svg": 76202,
	"./images/VideoControls/PauseButton.svg": 54126,
	"./images/VideoControls/PlayButton.svg": 63289,
	"./images/VideoControls/Vector (12).svg": 99493,
	"./images/VideoControls/backward-30.svg": 21342,
	"./images/VideoControls/backward.svg": 66012,
	"./images/VideoControls/badge-fill.svg": 79659,
	"./images/VideoControls/fast-forward.svg": 29394,
	"./images/VideoControls/forward-30.svg": 75670,
	"./images/VideoControls/forward-30_2x.png": 11286,
	"./images/VideoControls/full-screen.svg": 41206,
	"./images/VideoControls/fullscreen-exit.svg": 1096,
	"./images/VideoControls/high.svg": 30541,
	"./images/VideoControls/highFull.svg": 60540,
	"./images/VideoControls/low.svg": 42263,
	"./images/VideoControls/lowFilled.svg": 83189,
	"./images/VideoControls/medium.svg": 56023,
	"./images/VideoControls/mediumFilled.svg": 81752,
	"./images/VideoControls/muted.svg": 61576,
	"./images/VideoControls/pause.svg": 44783,
	"./images/VideoControls/pause_circular_2x.png": 95875,
	"./images/VideoControls/play.svg": 92371,
	"./images/VideoControls/play_circular_2x.png": 96440,
	"./images/VideoControls/playerSetting.svg": 4465,
	"./images/VideoControls/rewind-30_2x.png": 95802,
	"./images/VideoControls/round_backward_10.png": 58491,
	"./images/VideoControls/round_forward_10.png": 85242,
	"./images/VideoControls/setting.svg": 63180,
	"./images/VideoControls/settingRed.svg": 19229,
	"./images/VideoControls/speed.svg": 52347,
	"./images/VideoControls/volume.svg": 12874,
	"./images/airplay.svg": 87991,
	"./images/app-store.svg": 88100,
	"./images/authorsignature.png": 88275,
	"./images/banner.svg": 6079,
	"./images/briefcase.svg": 71076,
	"./images/bullet.svg": 20215,
	"./images/bulletred.svg": 80337,
	"./images/calendar.svg": 16762,
	"./images/call.svg": 49620,
	"./images/cancel-session.svg": 83030,
	"./images/cancelcheck.svg": 10961,
	"./images/card-img.png": 7252,
	"./images/cardThumbnailImage.svg": 15073,
	"./images/chevron-left-disabled.svg": 80084,
	"./images/chevron-left.svg": 803,
	"./images/chevron-right.svg": 87398,
	"./images/circle_check.svg": 22613,
	"./images/circle_check_green.svg": 77005,
	"./images/clock.svg": 9143,
	"./images/confirm.svg": 83136,
	"./images/copyToClipboard.svg": 12656,
	"./images/coupon.svg": 26201,
	"./images/cross.svg": 87241,
	"./images/cross2.svg": 99601,
	"./images/filledProfile.svg": 18910,
	"./images/hide.svg": 62146,
	"./images/info.svg": 41710,
	"./images/instructorIcon.svg": 43677,
	"./images/instructorInformation2.svg": 81787,
	"./images/instructors.svg": 54399,
	"./images/invalid.svg": 47619,
	"./images/large_lifedemy_thumb.png": 47890,
	"./images/left-arrow.svg": 47531,
	"./images/left-double-arrow.svg": 47962,
	"./images/lifedemyIcon.png": 50357,
	"./images/logoLarge.svg": 70110,
	"./images/mobNoti.svg": 81706,
	"./images/pencil.svg": 57937,
	"./images/playstore.svg": 80808,
	"./images/profile.svg": 26130,
	"./images/refund.svg": 33623,
	"./images/right-arrow.svg": 30348,
	"./images/right-double-arrow.svg": 60294,
	"./images/rupee.svg": 76962,
	"./images/searchIcon.svg": 22845,
	"./images/setting/language.svg": 22111,
	"./images/setting/push-notifcation.svg": 98259,
	"./images/setting/shield-lock-green.svg": 64189,
	"./images/setting/shield-lock.svg": 57104,
	"./images/setting/video-quality.svg": 35888,
	"./images/show.svg": 61744,
	"./images/star.svg": 83111,
	"./images/star2.svg": 26961,
	"./images/whatsaap.svg": 8349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72474;